// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__2ug3Z","header":"Post_header__27ru-","content":"Post_content__mdkZD","button":"Post_button__2gaSD"};